import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModelserviceService {

  
  private open = new Subject<void>();

  modelOpen$ = this.open.asObservable();

  openModel(content:any) {
    console.log('open Model')
    this.open.next(content);
  }

}
